export { default } from './OrderItemModal'



// WEBPACK FOOTER //
// ./src/App/components/OrderItemModal/index.js